import html from "../../images/html-5.png";
import css from "../../images/css.png";
import js from "../../images/javascript.png";
import react from "../../images/react.png";
import bootstrap from "../../images/bootstrap.png";
import express from "../../images/ExpressJS.png";
import firebase from "../../images/firebase.png";
import mongodb from "../../images/mongodb.png";
import mui from "../../images/mui.png";
import node from "../../images/nodejs.png";
import tailwind from "../../images/tailwindcss.svg";
import redux from "../../images/redux.png";
import sass from "../../images/sass.png";
import typescript from "../../images/typescript.png";

export const skills = [
  {
    img: html,
    name: "HTML5",
  },
  {
    img: css,
    name: "CSS3",
  },
  {
    img: js,
    name: "JavaScript",
  },
  {
    img: typescript,
    name: "Typescript",
  },
  {
    img: react,
    name: "React.js",
  },
  {
    img: mui,
    name: "Material UI",
  },
  {
    img: bootstrap,
    name: "Bootstrap",
  },
  {
    img: tailwind,
    name: "Tailwind",
  },
  {
    img: redux,
    name: "Redux",
  },
  {
    img: sass,
    name: "SASS",
  },
  {
    img: node,
    name: "Node.js",
  },
  {
    img: express,
    name: "Express.js",
  },
  {
    img: mongodb,
    name: "MongoDB",
  },
  {
    img: firebase,
    name: "Firebase",
  },
];
